const installerInitialState = {
	systemSaveSuccessfully: false,
	systemSaveFail: false,
	saveParametersSettingsSuccessfully: false,
	saveParametersSettingsFailed: false,
	mapUploadSuccessfully: false,
	mapUploadFailed: false,
	logoUploadSuccessfully: false,
	logoUploadFailed: false,
	mapUploadProgress: 0,
	mainMapUploadProgress: 0,
	secondMapUploadProgress: 0,
	thirdMapUploadProgress: 0,
	reportMapUploadProgress: 0,
	logoUploadProgress: 0,
	failedUploadMapFile: false,
	failedUploadLogoFile: false,
	savePolygonsSuccessfully: false,
	savePointsSuccessfully: false,
	savePolygonsFailed: false,
	savePointsFailed: false,
	boundaries: '',
	deleteSystemSuccessfully: false,
	deleteSystemFailed: false,
	deleteNodeSuccessfully: false,
	deleteNodeFailed: false,
	systemUpdatedViaWebsiteAt: null,
	swapDevicesSuccessfully: false,
	swapDevicesFailed: false,
	systemsForInstallerPanel: [],
	setSystemArchivedSuccessfully: false,
	setSystemArchivedFailed: false,
};

export default installerInitialState;
